import { createBrowserRouter, Navigate } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";
import PurchasePage from "./purchase/PurchasePage";
import PurchaseSuccess from "./purchase/PurchaseSuccess";
import PurchaseError from "./purchase/PurchaseError";
import SelecteProductPage from "./purchase/SelectProductsPage";

const purchaseRoutes = createBrowserRouter([
  {
    path: 'purchase',
    element: undefined,
    children: [
      { path: 'products', element: <SelecteProductPage />, index: true },
      { path: 'checkout', element: <PurchasePage /> },
      { path: 'success', element: <PurchaseSuccess /> },
      { path: 'error', element: <PurchaseError /> },
    ]
  },
  {
    path: '*',
    element: <Navigate to='/purchase/products' />
  }
]);

export default purchaseRoutes;